module.exports = __webpack_public_path__ + "ath_game_web/img/7.5.c52f27c5.png";